import { Meta, Title } from '@angular/platform-browser';
import {Component, OnInit,ViewChild, ElementRef, Renderer2} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {environment as env} from '../../../environments/environment';
import {ProductsService} from '../../services/products.service';
import {CartService} from '../../services/cart.service';
import {Productlist} from '../../models/productlist';
import {Category} from '../../models/category';
import {LanguageService} from '../../services/language.service';
import {SiteuserService} from '../../services/siteuser.service';
import { OrderonlineServiceService } from '../../services/orderonline-service.service';


@Component({ 
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.css']
})
export class ProductDetailsComponent implements OnInit {
  @ViewChild('cmodel') cmodel;
  @ViewChild('closeBtn') closeBtn;

  imgurl:string; 
  catslug:string;
  pslug:string;
  isEmpty:boolean = false;
  catName:string;
  catNameAr:string;
  cats:Category[] = [];
  productAr:any = []; 
  error:string;
  baseprice:any;
  addOns = [];
  varientOpt = [];
  newOpt = [];
  storedCart:any = [];
  orderOnlineBanner = [];
  qty:any;
  isLoading:boolean;
  varprice:any;
  finalprice:any;
  addonPrice:any;
  productExist:boolean; 
  cartMsg:string;
  cartMsg_ar:string;
  catname:string;
  newPrice:any;
  prodQty:number;
  addOnprice:any;
  optionPrice:any;
  optGradient = [];
  multiSelect:number;
  iswishlist:boolean;
  wishlistProductId:string;
  showLang:string;
  catname_ar:string;
  parentCatid: any;
  bookingHours: any;
  schDate:any;
  schTime:any;
  schMsg:string;
  schMsg_ar:string;
  restrictedQty = 4;
  isRestricted = 1;
  totalRestrictedQty = 0;
  minQtyMsg: any;
  seletecPopCheckbox: any;
  errorMessagePopCheckbox: any;
  displName:any;

  constructor(private srvprod:ProductsService,
    private el:ElementRef,
    private renderer:Renderer2,
    private srvcart:CartService,
    private http:HttpClient,
    private usrObj:SiteuserService,
    private router:Router,
    private route:ActivatedRoute,
    private langObj:LanguageService,
    private orderOnlieService:OrderonlineServiceService,
    private title: Title,private meta: Meta) {
    this.imgurl =  env.imgurl;
    
    this.langObj.langStr.subscribe((data)=>{
      this.showLang = data;
    });

    this.srvprod.varvalid.subscribe(prodAr=>{
      this.multiSelect = prodAr['multisel'];
      
      if(this.varientOpt.length > 0 ){
        for(var i=0; i < this.varientOpt.length; i++){
           if(this.multiSelect == 1){
              if(prodAr['pid'] == this.varientOpt[i]['orderitem_id'] && prodAr['optnid'] == this.varientOpt[i]['optionid'] && prodAr['vid'] == this.varientOpt[i]['optvalueid']){   
                this.varientOpt.splice(i, 1);
              }
           }else{
              if(prodAr['pid'] == this.varientOpt[i]['orderitem_id'] && prodAr['optnid'] == this.varientOpt[i]['optionid']){   
                this.varientOpt.splice(i, 1);
              }
           }
        }
      }
      this.productTotal(this.addOns, this.varientOpt);
    });


    this.srvprod.ingrdAr.subscribe(ingAr=>{
      if(this.optGradient.length > 0 ){
        for (var i=0;  i < this.optGradient.length; i++) {
          if(ingAr['gradeid'] == this.optGradient[i].ing_id && ingAr['ingvalue'] == this.optGradient[i]['selectedvalue'] ) {
            this.optGradient.splice(i, 1);
          }
        }
      }
    });

    
    this.srvprod.varientqtyArr.subscribe(prodAr=>{
      this.chkoptvl(prodAr);
    });

 }

  timings = [];
  ngOnInit(): void {

    let hours, minutes, ampm;
    for (let i = 420; i <= 1320; i += 15){
      hours = Math.floor(i / 60);
        minutes = i % 60;
        if (minutes < 10){
            minutes = '0' + minutes; // adding leading zero
        }
        ampm = hours % 24 < 12 ? 'AM' : 'PM';
        hours = hours % 12;
        if (hours === 0){
            hours = 12;
      }
      this.timings.push(hours + ':' + minutes + ' ' + ampm)
    }

    this.showLang = localStorage.getItem("showLang");
     if(this.showLang == null && this.showLang == undefined){
      this.showLang = 'en';
     }

    window.scroll(0,800);
    this.multiSelect=0;
    this.qty = 1;
    this.isLoading = true;
    this.addonPrice = 0;

    this.orderOnlieService.orderOnlineBanner('Order Now Banner').subscribe((data:any)=>{
      this.orderOnlineBanner = data.data[0];
    });

    this.srvprod.getallcats().subscribe(data => {
      if(data['data'].length <= 0){this.isEmpty = true;}
      this.cats = data['data'];
    },error=> {this.error  = error.message;});

    this.route.params.subscribe((params:Params)=>{
      if(params['catslug'] && params['pslug']){
        this.catslug = params['catslug'];
        this.pslug = params['pslug'];
      }else{ 
        // Redirect
      }

      this.srvprod.getProductSlug(this.pslug, this.catslug).subscribe(data => {   
        this.isLoading = false;
        this.productAr = data['data'];
        this.catname = data['catname'];
        this.catname_ar = data['catnameAr'];
        this.wishlistProductId = data['wishlistUserId'];
        this.baseprice = this.productAr.price;
        this.finalprice = this.productAr.price;
        this.varprice= this.productAr.price;
        this.parentCatid = this.productAr.pcategory_id;
        this.bookingHours = data['data'].bookingHours;
        if(this.productAr.pMetaTitle){
            var metaTitle = this.productAr.pMetaTitle;
        }else{
          var metaTitle = this.productAr.pName;
        }

        if(this.productAr.pMetaDesc){
            var metaDesc = this.productAr.pMetaDesc;
        }else{
          var metaDesc = this.productAr.pName;
        }

        if(this.productAr.pMetaKeywords){
          var metaKey = this.productAr.pMetaKeywords;
        }else{
          var metaKey = this.productAr.pName;
        }

        //console.log(this.productAr);

        this.title.setTitle(metaTitle);
        this.meta.updateTag({ name: 'description', content: metaDesc });
        this.meta.updateTag({ name: 'keywords', content: metaKey});
  
      },error=> {this.error  = error.message;});  
    })

  }

  chkadonvl(e){
    var amt = e.value;
    var addonName = e.getAttribute('adonName');
    var adonId = e.getAttribute('adonid');
    var valueName = e.getAttribute('valuename');
    var valueName_ar = e.getAttribute('valuename_ar');
    var valueId = e.getAttribute('valueid');
    var productId = e.getAttribute('pid');
    var addonPrice = e.value;
    var addonQty = e.getAttribute('qty');
    this.prodQty = addonQty;
    
    let addonArray = {
      "orderitem_id": productId,
      "addonname": addonName,
      "addonid": adonId,
      "valuename": valueName,
      "valuename_ar": valueName_ar,
      "valueid": valueId,
      "addonprice": addonPrice
    };
  
    if(e.checked){
      this.addOns.push(addonArray);
    }else{
      for (var i=0;  i < this.addOns.length; i++) {
          if(addonArray.valueid == this.addOns[i].valueid) {
            this.addOns.splice(i, 1);
          }
      }
    }
    this.productTotal(this.addOns, this.varientOpt);
  }

  optionValueTtl(){
    this.varientOpt = [];
    let selctchk = this.el.nativeElement.querySelectorAll('.optnchk:checked');
    
    for (const rb of selctchk) {    
      let optionname = rb.getAttribute('optnname');
      let optionname_ar = rb.getAttribute('optnname_ar');
      let optionid = rb.getAttribute('optnid');
      let optvaluename = rb.getAttribute('optnvalue');
      let optvaluename_ar = rb.getAttribute('optnvalue_ar');
      let productId = rb.getAttribute('pid');
      let optPrice = rb.getAttribute('price');
      let ovQty = rb.getAttribute('qty');
      this.prodQty = rb.getAttribute('qty');
      let optvalueid = rb.value;
      this.multiSelect = rb.getAttribute('multisel');
    
      let optionArray = {
        "orderitem_id": productId,
        "optionname": optionname,
        "optionname_ar": optionname_ar,
        "optionid": optionid,
        "optvaluename": optvaluename,
        "optvaluename_ar": optvaluename_ar,
        "optvalueid": optvalueid,
        "ovprice": optPrice,
        "ovqty":ovQty
      };
      this.varientOpt.push(optionArray);
    }
      
    this.productTotal(this.addOns, this.varientOpt);
  }

  chkoptvl(e) {
    this.optionValueTtl();
  }

  

  productTotal(addOn, option){
    //console.log(option);

    if(addOn != ''){
      this.addOnprice = 0;
      for(var i=0; i < addOn.length; i++){
       this.addOnprice = (parseFloat(this.addOnprice) + parseFloat(addOn[i]['addonprice'])).toFixed(2);
      }
    }else{
      this.addOnprice = 0;
    }

    if(option != ''){
      this.optionPrice = 0;
      for(var j=0; j < option.length; j++){
       this.optionPrice = (parseFloat(this.optionPrice) + (parseFloat(option[j]['ovprice']) * parseFloat(option[j]['ovqty']))).toFixed(2);
      }
    }else{
      this.optionPrice = 0;
    }
    this.newPrice = (parseFloat(this.baseprice) + parseFloat(this.addOnprice) + parseFloat(this.optionPrice)).toFixed(2);
    this.finalprice = (this.newPrice * this.qty).toFixed(2);

    // console.log(' baseprice is - '+this.baseprice);
    // console.log('addOnprice Price is - '+this.addOnprice);
    // console.log('optionPrice Price is - '+this.optionPrice);
    // console.log('New Price is - '+this.newPrice);
    // console.log('Final Price  is - '+this.finalprice);
  }

  checkGradient(e){
    var gradeName = e.getAttribute('gradeName');
    var gradeId = e.getAttribute('gradeid');
    var productId = e.getAttribute('pid');
    var slectedVal = e.value;
    let gradientArray = { 
      'ingName': gradeName,
      'ing_id': gradeId,
      'product_id': productId,
      'selectedvalue': slectedVal
    }
    
    if(this.optGradient.length > 0 ){
      var existGradient = false;
      for (var i=0;  i < this.optGradient.length; i++) {
        if(gradientArray.ing_id == this.optGradient[i].ing_id) {
          existGradient = true;
          this.optGradient[i] = gradientArray;
          break;
        }
      }
    }else{
      this.optGradient.push(gradientArray);
    }

    if(existGradient == false){
      this.optGradient.push(gradientArray);
    }

  }

  formatDate(dateVal) {
    let newDate = new Date(dateVal);

    let sMonth = this.padValue(newDate.getMonth() + 1);
    let sDay = this.padValue(newDate.getDate());
    let sYear = newDate.getFullYear();
    let sHour = newDate.getHours();
    let sMinute = this.padValue(newDate.getMinutes());
    let sAMPM = "AM";

    var iHourCheck = sHour;

    if (iHourCheck > 12) {
        sAMPM = "PM";
        sHour = iHourCheck - 12;
    }else if (iHourCheck === 0) {
        sHour = 12;
    }

    sHour = this.padValue(sHour);

    return sMonth + "-" + sDay + "-" + sYear + " " + sHour + ":" + sMinute + " " + sAMPM;
  }

  padValue(value) {
      return (value < 10) ? "0" + value : value;
  }



  addtoCart(prod, id, price, finalprice, qty, image, pname_ar, coment, pQty, feast) {
    // console.log(this.productAr.poptions);
    // console.log('Selected Options', this.varientOpt)
    
    for (let index = 0; index < this.productAr.poptions.length; index++) {
      const optn = this.productAr.poptions[index];
      if (optn.isRestricted == 1) {
        let totalQty = 0;
        this.varientOpt.map((nEl) =>{  
          if(nEl.optionid == optn.id){
            totalQty =  totalQty+parseInt(nEl.ovqty);
          }
        });
              
        if (totalQty != optn.qnty) {
          this.displName = optn.option_display_name;
          this.minQtyMsg = `Please select ${optn.qnty} quantity from ${optn.option_display_name}`
           //this.minQtyMsg = `Please select ${optn.qnty} quantity`
          return
        }

      }
    }

    // ++++++++++++++++++++++++++++++++

    //console.log(this.bookingHours);
    const today = new Date();
    const cdate = today.setHours(today.getHours() + parseInt(this.bookingHours));
    const userdate = new Date(this.schDate + " " + this.schTime);
    if (userdate < today) {
      this.schMsg = "Allow us a minimum of "+this.bookingHours+" hours to freshly prepare your food. Thank you!";
      return
    }

    if(feast == 1){
      //convert current time to UAE time
      const date1 = new Date();
      
      if(this.schDate == undefined || this.schDate == '' ){ 
        this.schMsg = "Select delivery date";
        this.schMsg_ar = "حدد تاريخ التسليم";
        return false;
      }else{
        const date2 = new Date(this.schDate);
        var Timehours = Math.abs(date1.getTime() - date2.getTime()) / 36e5;
        this.schMsg ='';
      }

      //time 
      if(this.schTime == undefined || this.schTime == ''){
        this.schMsg = "Select delivery time";
        this.schMsg_ar = "اختر من وقت";
        return false;
      }else{
        var totalTime = Timehours + parseInt(this.schTime);
        this.schMsg ='';
      }
    }
    
    var priceWithaddon = (parseFloat(finalprice) / qty ).toFixed(2);
    var produrl = this.router.url;
    let prodArray = { 
      "pName": prod,
      "pName_ar": pname_ar,
      "pId": id,
      "pslug":this.pslug,
      "pComent": coment,
      "catslug":this.catslug,
      "pImage": image,
      'pUrl':produrl,
      "basePrice": price,
      "totalPrice": finalprice,
      "priceWithaddon": priceWithaddon,
      "qty": qty,
      "addons": this.addOns,
      "varients": this.varientOpt,
      "ingradients": this.optGradient,
      "parentCatid": this.parentCatid,
      "avlpQty": pQty,
      "isFeast": feast,
      "isFeastDate": feast == 1 ? this.schDate : null,
      "isFeasTime": feast == 1 ? this.schTime : null,
      "sno": Date.now()
    };

    this.srvcart.checkCart(prodArray);
     console.log('Final result');
     console.log(this.srvcart.cartvaliReturn);
    this.storedCart = JSON.parse(localStorage.getItem("cartData"));
    if(this.srvcart.cartvaliReturn['result'] == 'add'){
      this.cartMsg = "Item has been added to the cart";
      this.cartMsg_ar = "تمت إضافة العنصر إلى سلة التسوق";
      //console.log('yes add');
      //return false;
     
     if(this.storedCart != null && this.storedCart.length > 0){
          localStorage.setItem("cartData", JSON.stringify(this.storedCart));
          this.storedCart.push(prodArray);
          localStorage.setItem("cartData", JSON.stringify(this.storedCart));
          this.srvcart.cartItemCount();
          this.cmodel.nativeElement.click();
          setTimeout (() => {
            this.closeBtn.nativeElement.click();
        }, 1000);

     }else{
        var cartArray = [];
        cartArray.push(prodArray);
        localStorage.setItem("cartData", JSON.stringify(cartArray));
        this.srvcart.cartItemCount();
        this.cmodel.nativeElement.click();
          setTimeout (() => {
            this.closeBtn.nativeElement.click();
        }, 1000);
     }

    }

    if(this.srvcart.cartvaliReturn['result'] == 'update'){
      this.cartMsg = "Cart updated successfully";
      this.cartMsg_ar = "تم تحديث سلة التسوق بنجاح";
      var cartPos = this.srvcart.cartvaliReturn['cid'];

      for(var i=0; i < this.storedCart.length; i++){
        if(this.storedCart[i].sno == cartPos){
          this.storedCart[i].qty = this.storedCart[i].qty + 1;
          this.storedCart[i].totalPrice = this.storedCart[i].priceWithaddon * this.storedCart[i].qty;
          localStorage.setItem("cartData", JSON.stringify(this.storedCart));
          break;
        }
        
      }

      this.cmodel.nativeElement.click();
        setTimeout (() => {
          this.closeBtn.nativeElement.click();
       }, 1000);

 
    }


    //store product varients data in an array
    let cartvarients = [];
    
    
    // this.productExist = false;
    // this.storedCart = JSON.parse(localStorage.getItem("cartData"));
    // if(this.storedCart != null && this.storedCart.length > 0){
    //   localStorage.setItem("cartData", JSON.stringify(this.storedCart));

    //   if(this.productExist == false){
    //     this.storedCart.push(prodArray);
    //     localStorage.setItem("cartData", JSON.stringify(this.storedCart));
    //     this.srvcart.cartItemCount();
    //     this.cmodel.nativeElement.click();
    //     setTimeout (() => {
    //       this.closeBtn.nativeElement.click();
    //    }, 1000);
    //   }else{
    //     this.cartMsg = "Cart updated successfully";
    //     this.cartMsg_ar = "تم تحديث سلة التسوق بنجاح";
    //     this.cmodel.nativeElement.click();
    //     setTimeout (() => {
    //       this.closeBtn.nativeElement.click();
    //    }, 1000);
    //   }

    // }else{
    //   var cartArray = [];
    //   cartArray.push(prodArray);
    //   localStorage.setItem("cartData", JSON.stringify(cartArray));
    //   this.srvcart.cartItemCount();
    //   //this.router.navigate(['/cart']);
    //   this.cmodel.nativeElement.click();
    //     setTimeout (() => {
    //       this.closeBtn.nativeElement.click();
    //    }, 1000);
    // }

  }


  incQty(qty,price, avlpQty){
    this.qty = parseInt(qty) + 1;
    if(this.parentCatid == 19 && avlpQty != null){
       if(this.qty > avlpQty){
          this.qty = parseInt(qty);
          this.cartMsg = "Please select fewer quantity and try.";
          this.cmodel.nativeElement.click();
          setTimeout (() => {this.closeBtn.nativeElement.click();}, 4000);
          return;
          
       }
    }

    if(this.addOns.length > 0 || this.varientOpt.length > 0){
      this.productTotal(this.addOns, this.varientOpt)
    }else{
      this.finalprice = (this.qty * parseFloat(price)).toFixed(2);
    }
    
  }

  desQty(qty,price){
    if(qty > 0){
      if(qty == 1){
        if(this.addOns.length > 0 || this.varientOpt.length > 0){
          this.productTotal(this.addOns, this.varientOpt)
        }else{
          this.finalprice = parseFloat(price).toFixed(2);
        }
        
      }else{
        this.qty = parseInt(qty) - 1;
        if(this.addOns.length > 0 || this.varientOpt.length > 0){
          this.productTotal(this.addOns, this.varientOpt)
        }else{
          this.finalprice = ((qty * parseFloat(price)) - parseFloat(price) ).toFixed(2);
        }
        
      }
    }
  }

  incQtyOffer(data) {
    if (data.qty) {
      data.qty = parseInt(data.qty) + 1;
    } else {
      data.qty = 1;
    }
  }

  desQtyOffer(data, resData){
    if (data.qty) {
      if (data.qty != 0) {
        data.qty = data.qty - 1;
      }
    } else {
      data.qty = 0;
    }    
  }

  addtoWishlist(pid){
    if(this.usrObj.loggedIn() == true){
      var userId = localStorage.getItem("sajid");
      this.orderOnlieService.addTowishlist(pid, userId).subscribe((data:any)=>{
        if(data['success']){
          if(data['data'] !=''){
            this.iswishlist = true;
            this.cartMsg = "Item added to favorites";
            this.cartMsg_ar = "تمت إضافة العنصر إلى المفضلة";
            this.cmodel.nativeElement.click();
            setTimeout (() => {this.closeBtn.nativeElement.click();}, 1000);
          }else{
            this.iswishlist = true;
            this.cartMsg = "Item already in favorites";
            this.cartMsg_ar = "العنصر موجود بالفعل في المفضلة";
            this.cmodel.nativeElement.click();

            setTimeout (() => {
            this.closeBtn.nativeElement.click();
            }, 2000);
          }
        }    
      });

    }else{
      this.router.navigate(['/login', { wishlist: 1 }]);
    }
  }

  getDate(val){
      this.schDate = val;
  }

  getfromTime(val){
      this.schTime = val;
  }



}